import { STATUS_META, TONE_CLASSES } from "@/lib/entries";

export default function StatusBadge({ status }) {
  const meta = STATUS_META[status];
  if (!meta) return null;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded border text-[11px] font-medium ${TONE_CLASSES[meta.tone]}`}
      data-testid={`status-badge-${status}`}
    >
      {meta.short}
    </span>
  );
}
